export default __webpack_public_path__ + "static/media/trash.37b3c7e7.svg";